export const baseTheme = {
  doughnutChartDanger: '#ff1e5a',
  doughnutChartPrimary: '#358df4',
  doughnutChartBackground: '#dededf',

  rangeSliderFilled: '#1b50c8',
  rangeSliderEmpty: '#dededf',
  
  voucherGeneratedStatus: '#666666',
  voucherExpiredStatus: '#FF1E5A',
  voucherUsedStatus: '#358DF4',

  dashboardSettingsButtonAppearance: 'outline',
  dashboardSettingsButtonStatus: 'control',

  chartTimeUsedColors: [
    'rgba(255, 30, 90, 0.5)',
    'rgba(53, 141, 244, 0.3)'
  ],

  chartMaterialColors: [
    '#FF7F83',
    '#FF7FFA',
    '#977FFF',
    '#7FD3FF',
    '#7FFFCA',
    '#AAFF7F',
    '#ffe055',
  ],
};